<template>
  <div :style="containerStyle"></div>
</template>
<script src="./index.js"></script>